import React from 'react';

import {
    Box,
    Container as MaterialContainer,
    Grid,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { HeaderContainer, TitleIcon } from 'common/components';
import ResumeData from 'common/components/ResumeData';
import { RESET_PASSWORD_IN_PROFILE } from 'common/modules/managePassword/constants';
import ManagePassword from 'common/modules/managePassword/Container';

import ProfileConfiguration from '../profileConfiguration';

import DataForm from './components/DataForm';

const Container = ({ match }) => {
    const { t } = useTranslation();

    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon title={t('My profile')} />
                </Grid>
            </HeaderContainer>

            <ResumeData
                isOpen={match?.params?.section === 'general'}
                title={t('General information')}
            >
                <DataForm />
            </ResumeData>

            <ResumeData
                isOpen={match?.params?.section === 'security'}
                title={t('Security')}
            >
                <Typography variant="body2" fontWeight="bold">
                    {t('Password')}
                </Typography>

                <Box sx={{ mt: 1 }}>
                    <ManagePassword origin={RESET_PASSWORD_IN_PROFILE} />
                </Box>
            </ResumeData>

            <ResumeData
                isOpen={match?.params?.section === 'settings'}
                title={t('Setting')}
            >
                <ProfileConfiguration.Container />
            </ResumeData>
        </MaterialContainer>
    );
};

Container.propTypes = {
    match: PropTypes.object,
};

export default withRouter(Container);
